import React, { useState, useEffect } from 'react'
import BaseFilter from '../../components/BaseFilter'
import { Check, Clear, CollectionsBookmark, Close } from '@mui/icons-material'
import { Box, Grid, IconButton, Divider, InputAdornment } from '@mui/material'
import DefaultPainel from '../../components/shared/Painel'
import AdaptativeGridContainer from '../../components/shared/AdaptativeGridContainer'
import BooksTable from './components/TableLivros'
import CadLivroModal from './components/CadLivrosModal'
import EditLivroModal from './components/EditLivrosModal'
import { useNavigate } from 'react-router-dom'
import rotas from '../../services/rotas'
import PrivateRC from '../../components/PrivateRC'
import TableHeader from '../../components/shared/tables/TableHeader'
import Dater from '../../services/DateFormat'
import gerarPaginacao from '../../services/pagination'
import { Obras } from '../../services/http'
import filter from './filters'
import AutorTooltip from './components/AutorTooltip'
import BaseTooltip from '../../components/BaseTooltip'
import SmallTextField from '../../components/textfield/SmallTextfield'
import SearchEndAdornment from '../../components/adornment/SearchEndAdornment'
import SearchStartAdornment from '../../components/adornment/SearchStartAdornment'
import MobileFilterHeaderContainer from '../../components/filters/MobileFilterHeaderContainer'

const Livros = () => {
  const [rows, setRows] = useState([])
  const [queryTitle, setQueryTitle] = useState([])
  const [queryNumberPage, setQueryNumberPage] = useState()
  const [query, setQuery] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [lastPage, setLastPage] = useState(0)
  const navigate = useNavigate()
  const [tloading, setTloading] = useState(false)

  const getBooks = async (filters = {}, page = 1) => {
    setTloading(true)
    const { data } = await Obras().show({
      page,
      ...filters,
      includes: ['categoriaObra', 'obraAutores.autor'],
      count: 'exemplares'
    })
    setLastPage(data.last_page)
    setCurrentPage(data.current_page)
    const aux = data.data.map(item => ({
      ...item,
      id: item.id,
      autor: item?.obra_autores,
      categoria: item?.categoria_obra?.descricao,
      disponivel: item?.exemplares_count > 0,
      cadastro: Dater().formatar(item.created_at, 'dd/mm/yyyy'),
      quantidade: item?.exemplares_count
    }))
    setRows([...aux])
    setTloading(false)
  }

  let typingTimer = ''

  const getBooksTitle = () => {
    setQuery(Object.assign(query, { titulo: `%${queryTitle?.toUpperCase()}%` }))
    getBooks(query)
  }

  const getBooksNumberPage = () => {
    setQuery(Object.assign(query, { numero_pagina: `%${queryNumberPage}%` }))
    getBooks(query)
  }

  const handleClean = () => {
    if (queryTitle !== '') {
      setQueryTitle('')
      delete query.titulo
      getBooks({ ...query, titulo: undefined })
    }
  }

  const handleCleanNumberPage = () => {
    if (queryNumberPage !== '') {
      setQueryNumberPage('')
      delete query.numero_pagina
      getBooks(query)
    }
  }

  const verificaPath = (path = '') => {
    const url = path.replace(/%/g, '%25')
    return url
  }
  const headers = [
    {
      field: 'titulo',
      headerName: 'Titulo',
      flex: 2
    },
    {
      field: 'autor',
      headerName: 'Autor',
      flex: 1.2,
      renderCell: ({ row }) => {
        return <AutorTooltip title={row.autor} />
      }
    },
    {
      field: 'categoria',
      headerName: 'Categoria',
      flex: 1.5
    },

    {
      field: 'disponivel',
      headerName: (
        <BaseTooltip
          title="Possui pelo menos 1 exemplar ativo"
          light
          followCursor
        >
          Disponível
        </BaseTooltip>
      ),
      flex: 1,
      renderCell: ({ row }) => {
        return row.disponivel === true ? (
          <Check color="success" />
        ) : (
          <Clear color="error" />
        )
      }
    },

    {
      field: 'quantidade',
      headerName: (
        <BaseTooltip title="Quantidade de exemplares" light followCursor>
          Quant.
        </BaseTooltip>
      ),
      flex: 0.7
    },
    {
      field: 'cadastro',
      headerName: 'Cadastro',
      flex: 1
    },
    {
      field: 'numero_pagina',
      headerName: 'N. Páginas',
      flex: 1
    },
    {
      field: 'actions',
      headerName: 'Ações',
      renderCell: ({ row }) => (
        <>
          <PrivateRC permission="obras#update">
            <EditLivroModal
              getBooks={() => getBooks(query, currentPage)}
              data={row}
            />
          </PrivateRC>
          <PrivateRC permission="obras#list-id">
            <BaseTooltip title="Ver exemplares" light followCursor>
              <IconButton
                color="leitura"
                onClick={() =>
                  navigate(
                    `${rotas.livro}/${row.id}/&name:${encodeURIComponent(
                      row.titulo
                    )}`
                  )
                }
              >
                <CollectionsBookmark />
              </IconButton>
            </BaseTooltip>
          </PrivateRC>
        </>
      ),
      flex: 1
    }
  ].map(item => ({ ...item, align: 'center', sortable: false }))

  const pagination = gerarPaginacao(
    true,
    lastPage,
    currentPage,
    (event, value) => getBooks(query, value)
  )

  useEffect(() => {
    getBooks()
  }, [])

  return (
    <DefaultPainel sx={{ mt: '4vh', p: 2 }}>
      <AdaptativeGridContainer>
        <>
          <TableHeader
            titulo="Lista de livros"
            controls={
              <MobileFilterHeaderContainer>
                <SmallTextField
                  color="white"
                  type="text"
                  placeholder="Título"
                  variant="standard"
                  onKeyDown={() => {
                    clearTimeout(typingTimer)
                  }}
                  onKeyUp={() => {
                    clearTimeout(typingTimer)
                    typingTimer = setTimeout(getBooksTitle, 1000)
                  }}
                  onChange={({ target }) => {
                    setQueryTitle(target.value)
                  }}
                  value={queryTitle}
                  InputProps={{
                    sx: {
                      minWidth: '200px'
                    },
                    style: { color: 'white' },
                    startAdornment: <SearchStartAdornment />,
                    endAdornment: <SearchEndAdornment action={handleClean} />
                  }}
                />
                <PrivateRC permission="bibliotecas#store">
                  <CadLivroModal getBooks={getBooks} />
                </PrivateRC>
                <BaseFilter
                  sx={{ margintop: '10px' }}
                  filter={filter}
                  color="white"
                  onChange={value => {
                    setQuery(Object.assign(query, value))
                    getBooks(query)
                  }}
                  variant="outlined"
                  components={
                    <SmallTextField
                      type="number"
                      placeholder="Nº Páginas"
                      variant="outlined"
                      onKeyDown={() => {
                        clearTimeout(typingTimer)
                      }}
                      onKeyUp={() => {
                        clearTimeout(typingTimer)
                        typingTimer = setTimeout(getBooksNumberPage, 1000)
                      }}
                      onChange={({ target }) => {
                        setQueryNumberPage(target.value)
                      }}
                      value={queryNumberPage}
                      InputProps={{
                        sx: {
                          minWidth: '200px'
                        },
                        endAdornment: (
                          <InputAdornment position="start">
                            <IconButton
                              sx={{ marginBottom: '3px' }}
                              onClick={() => handleCleanNumberPage()}
                            >
                              <Close />
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                  }
                />
              </MobileFilterHeaderContainer>
            }
          />
          <Grid item xs={12} sm={12}>
            <Divider />
            <BooksTable
              rows={rows}
              columns={headers}
              rowsPerPageOptions={[10]}
              disableColumnMenu
              disableColumnSelector
              pagination={pagination}
              loading={tloading}
            />
          </Grid>
        </>
      </AdaptativeGridContainer>
    </DefaultPainel>
  )
}
export default Livros
